import { Block, FlexBox, IconBackGroundClientReviewBottomLeft, IconBackGroundClientReviewTopRight, Spacer, TextCommon, useHttpCommand } from '@esg/ui';
import { ReviewForm } from './children/ReviewForm';
import './Home.scss';
import { useEffect, useState } from 'react';
import { SuccessReviewToGoogleMap } from './children/SuccessReviewToGoogleMap';
import { getDetailSaleBasic, GetDetailSaleBasicResponse } from '@esg/business-pos';
import { getEnv } from '@esg/shared';
import { SuccessReview } from './children/SuccessReview';
import { checkReview, ClientReviewCreateResponse } from '@esg/business-client-review';
import TransactionDetails from './children/TransactionDetails';
import { Image } from 'antd';
import ClientReviewLocalesProvider from './ClientReviewLocalesProvider';

export function Home() {
  const [sale, setSale] = useState<GetDetailSaleBasicResponse | null>();
  const [reviewResponse, setReviewResponse] = useState<ClientReviewCreateResponse>();
  const [isShowSuccess, setIsShowSuccess] = useState('REVIEW_FORM');
  const [activePanel, setActivePanel] = useState<'LEFT' | 'RIGHT'>('RIGHT');
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 932);
  const [customerId, setCustomerId] = useState<string>();
  const [saleId, setSaleId] = useState<string>();
  const path = window.location.pathname;
  const tokenRating = path.split("/").pop() ?? '';
  const encoded = tokenRating;
  const decoded = atob(encoded);
  const { idSaleRating, branchId } = splitAndAssign(decoded);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 932);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function splitAndAssign(input: string) {
    const [idSaleRating, organizationId, branchId, tenantId] = input.split('*');

    return { idSaleRating, organizationId, branchId, tenantId };
  }
  const headerRequest: Record<string, string> = {
    Authorization: `Basic ${btoa(`${getEnv().USER_BASIC_AUTH}:${getEnv().PASSWORD_BASIC_AUTH}`)}`,
  };
  const { mutateAsync: getCurrentSale } = useHttpCommand(getDetailSaleBasic);
  const { mutateAsync: getCheckReview } = useHttpCommand(checkReview);

  useEffect(() => {
    const fetchSale = async () => {
      try {
        const sale = await getCurrentSale({
          pathData: {
            id: idSaleRating ?? '',
          },
          header: headerRequest,
        });
        setSale(sale);
        setCustomerId(sale.customerId);
        setSaleId(sale.id);
        const fetchGetCheckReview = async () => {
          const checkReview = await getCheckReview({
            pathData: {
              reviewToken: sale.id
            },
            header: headerRequest,
            query: {
              saleId: sale.id
            },
          });
          if ((Object.keys(checkReview).length > 0)) {
            setIsShowSuccess('SUCCESS_REVIEW');
          }
        };
        fetchGetCheckReview();
      } catch (error) {
        console.error("Error fetching sale:", error);
      }
    };
    fetchSale();
  }, []);

  const handleShowSuccess = (review: ClientReviewCreateResponse) => {
    if (review.rating! >= 5) {
      setReviewResponse(review);
      setIsShowSuccess('GOOGLE_MAP');
    }
    if (review.rating! < 5) {
      setIsShowSuccess('SUCCESS_REVIEW');
    }
  };

  const handleSetActivePanel = (key: 'LEFT' | 'RIGHT') => {
    setActivePanel(key);
  };

  const showReviewForm = isShowSuccess === 'REVIEW_FORM' && customerId && saleId && branchId;
  const showSuccessReviewToGoogleMap = isShowSuccess === 'GOOGLE_MAP' && reviewResponse && customerId && saleId && branchId;
  const showSuccessReview = isShowSuccess === 'SUCCESS_REVIEW';
  const isGetBranch = sale?.branch !== undefined;

  return (
    isGetBranch &&
    <ClientReviewLocalesProvider branch={sale?.branch}>
      <Block className='home-custom'>
        <Block className={`content-custom-left ${isMobile ? (activePanel === 'LEFT' ? 'active' : 'hidden') : ''}`}>
          {
            sale && <TransactionDetails
              isMobile={isMobile}
              handleSetActivePanel={handleSetActivePanel}
              sale={sale}
            />
          }
        </Block>
        <Block className={`content-custom-right ${isMobile ? (activePanel === 'RIGHT' ? 'active' : 'hidden') : ''}`}>
          <IconBackGroundClientReviewBottomLeft className="background-bottom-left-icon" />
          <FlexBox direction='column' justifyContent='center' alignItems='center'>
            <Image width={200} preview={false} src='https://id.izisalon.dev/assets/auth/logo_sologan_black.svg' ></Image>
            <Spacer height={50}></Spacer>
            {showReviewForm && <ReviewForm
              isMobile={isMobile}
              handleSetActivePanel={handleSetActivePanel}
              urlLogo={sale?.branch.logo}
              headerRequest={headerRequest}
              handleShowSuccess={handleShowSuccess}
              customerId={customerId}
              saleId={saleId}
              branchId={branchId}
              salonName={sale?.branch.name}
            />}
            {showSuccessReviewToGoogleMap && <SuccessReviewToGoogleMap
              saleDetail={sale}
              defaultValues={reviewResponse}
              headerRequest={headerRequest}
              handleShowSuccess={handleShowSuccess}
            />}
            {showSuccessReview && <SuccessReview />}
            <Spacer height={50}></Spacer>
            <TextCommon>izisalon.com</TextCommon>
            <Spacer height={20} />
          </FlexBox>
          <IconBackGroundClientReviewTopRight className="background-bottom-right-icon" />
        </Block>
      </Block >
    </ClientReviewLocalesProvider>
  );
}
